import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../../../../environments/environment";
import { AuthService } from "../../../../../core/service/auth.service";

@Injectable({
  providedIn: 'root'
})

export class FavoriteEstablishmentService {
  private readonly _apiUrl = environment.apiUrl;
  constructor(private http: HttpClient,
    private authService: AuthService
  ) {

  }
  enabledEstablishmentFavorite(idRestaurant: number): Observable<{ message: string, status: boolean }> {

    const tokenUser = this.authService.getToken();
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${tokenUser}`,
      'Content-Type': 'application/json'
    });

    return this.http.post<{ message: string, status: boolean }>(`${this._apiUrl}/favorite/delete`, { idRestaurant }, {
      headers
    });
  }

  disabledEsablishmentFavorite(idRestaurant: number): Observable<{ message: string, status: boolean }> {
    const tokenUser = this.authService.getToken();
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${tokenUser}`,
      'Content-Type': 'application/json'
    });

    return this.http.post<{ message: string, status: boolean }>(`${this._apiUrl}/favorite/add`, { idRestaurant }, { headers });
  }
}
